import { FC, useState } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native-web';
import { vw } from '../../utils/tool/vw';
import { $white } from '../constants/style';
import { useUiString } from '../../utils/hook/useUiString';

interface ExpandableTextProps {
    text: string | undefined;
    maxLength?: number;
    style?: any;
    buttonStyle?: any;
    buttonTextStyle?: any;
    onTextPress?: () => void;
}

export const ExpandableText: FC<ExpandableTextProps> = ({
    text,
    maxLength = 120,
    style,
    buttonStyle,
    buttonTextStyle,
    onTextPress,
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const t = useUiString();

    if (!text) {
        return null;
    }

    const getTruncatedText = (text: string): string => {
        const sentenceEndPattern = /[.!?]+\s+/;
        const match = text.match(sentenceEndPattern);

        if (match && match.index !== undefined) {
            const firstSentenceEnd = match.index + match[0].length;
            const firstSentence = text.substring(0, firstSentenceEnd).trim();

            if (firstSentence.length > maxLength) {
                return text.substring(0, maxLength).trim();
            }

            return firstSentence;
        }

        return text.length > maxLength ? text.substring(0, maxLength).trim() : text;
    };

    const truncatedText = getTruncatedText(text);
    const truncatedTextTrimmed = truncatedText.trim();
    const fullTextTrimmed = text.trim();
    const shouldTruncate = truncatedTextTrimmed.length < fullTextTrimmed.length;

    const displayText = isExpanded 
        ? text 
        : (shouldTruncate ? `${truncatedText}` : text);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
        if (onTextPress) {
            onTextPress();
        }
    };

    return (
        <View style={styles.container}>
            <Pressable onPress={toggleExpanded}>
                <Text style={[styles.text, style]}>
                    {displayText}
                </Text>
            </Pressable>
            {shouldTruncate && (
                <Pressable onPress={toggleExpanded} style={[styles.button, buttonStyle]}>
                    <Text style={[styles.buttonText, buttonTextStyle]}>
                        {isExpanded ? t('showLess') : t('readMore')}
                    </Text>
                </Pressable>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: vw(8),
    },
    text: {
        color: $white,
        fontSize: vw(13),
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: vw(18),
        letterSpacing: -0.078,
        maxWidth: vw(285),
    },
    button: {
        alignSelf: 'flex-start',
        marginTop: vw(4),
    },
    buttonText: {
        color: $white,
        fontSize: vw(12),
        fontStyle: 'normal',
        fontWeight: '600',
        textDecorationLine: 'underline',
        letterSpacing: -0.078,
    },
});